import React from "react";
import Spiner from "./spinner";

const Button = ({
    className,
    icon,
    imgStyle,
    alt,
    onClick,
    label,
    status,
    disabled = false,
    type = "button",
    loading = false,
    loadingDelete = false,
    id,
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            className={`relative ${className}`}
            disabled={loading || disabled || loadingDelete}
            id={id}
        >
            {!loading && label}
            {loading ? (
                <Spiner />
            ) : (
                icon && <img className="ms-3" src={icon} alt={alt} width="22" />
            )}
        </button>
    );
};

export default Button;